import { useAppSelector } from 'shared';

export const useCateringPageState = () => useAppSelector((store) => store.cateringPage);
